import React, { useState, useEffect } from 'react'

import { useParams } from '@reach/router'

import { Box, Inline, Stack, Text } from '@myxplor/stardust'
import { ignitionPost } from '~/utils/ignitionFetch'

const EddrWrapper = ({ question }) => {
  const { guid } = useParams()
  const isReEnrolment = !!guid
  const serviceId = question.getPropertyValue('service_id')
  const [eddrObject, setEddrObject] = useState({
    is_enabled: question.value ? question.value.is_enabled : false,
    html: question.value ? question.value.html : '',
    is_checked: question.value ? question.value.is_checked : false
  })
  const [eddrResponse, setEddrResponse] = useState(null)

  const getEddr = () => {
    ignitionPost(`api/v1/debit_success_eddr_config/${serviceId}`)
      .then(res => {
        const resDataEddr = res.data.eddr

        setEddrResponse(resDataEddr)
        setEddrObject({ ...eddrObject, ...resDataEddr })

        question.value = { ...eddrObject, ...resDataEddr }
      })
      .catch(res => {
        alert(res.errors ? res.errors : 'An error occurred while fetch debit success eddr config.')
      })
  }

  const handleIsEddrCheck = () => {
    const newEddr = { ...eddrObject, is_checked: !eddrObject.is_checked }
    question.value = newEddr
    setEddrObject(newEddr)
  }

  useEffect(() => {
    if (!isReEnrolment) {
      getEddr(serviceId)
    }
  }, [])

  return (
    <Box>
      {eddrResponse && eddrResponse.is_enabled && (
        <Stack space="xsmall">
          <Text fontSize="16px" color="highestEmphasis">
            Electronic Direct Debit Request (EDDR)
          </Text>

          <Box
            border="solid 1px black"
            overflowY="scroll"
            maxHeight="300px"
            padding="small"
            lineHeight={10.5}
            dangerouslySetInnerHTML={{ __html: eddrResponse.html }}
          />

          <Inline align="right" alignY="center" space="small">
            <Text color="highestEmphasis" weight="bold" italic>
              I have read and understood the above mentioned and agree to the terms. *
            </Text>
            <input
              type="checkbox"
              id="eddr"
              name="eddr"
              defaultChecked={eddrObject.is_checked}
              onChange={handleIsEddrCheck}
            />
          </Inline>
        </Stack>
      )}
    </Box>
  )
}

export default EddrWrapper
